class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // Build the added-product card client-side from the item JSON that is
    // already in the /cart/add.js response. Avoids server-rendering the
    // cart-notification-product section (which loops ALL cart items and
    // dominates the response payload).
    const productEl = document.getElementById('cart-notification-product');
    if (productEl) productEl.innerHTML = this.buildProductHTML(parsedState);

    // Only the count-dependent sections still come from the server. These are
    // tiny and need the cart total, which the single-item response lacks.
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];
      if (el && html) el.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  buildProductHTML(item) {
    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
        ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
      );

    let imgHTML = '';
    const imgUrl = item.image || (item.featured_image && item.featured_image.url);
    if (imgUrl) {
      const sized = imgUrl.replace(/(\.[a-z]+)(\?.*)?$/i, '$1?width=140');
      imgHTML =
        '<div class="cart-notification-product__image global-media-settings">' +
        `<img src="${esc(sized)}" alt="${esc(item.product_title)}" width="70" height="70" loading="lazy">` +
        '</div>';
    }

    let optionsHTML = '';
    if (!item.product_has_only_default_variant && Array.isArray(item.options_with_values)) {
      optionsHTML = item.options_with_values
        .map(
          (o) =>
            `<div class="product-option"><dt>${esc(o.name)}:</dt><dd>${esc(o.value)}</dd></div>`
        )
        .join('');
    }

    return (
      `<div id="cart-notification-product-${esc(item.key)}" class="cart-item">` +
      imgHTML +
      '<div>' +
      `<h3 class="cart-notification-product__name h4">${esc(item.product_title)}</h3>` +
      `<dl>${optionsHTML}</dl>` +
      '</div>' +
      '</div>'
    );
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
